// src/hooks/useUrlNavigation.js
import { useSearchParams, useNavigate } from "react-router-dom";
import { useCallback } from "react";

export function useUrlNavigation() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const getParam = useCallback(
    (param) => searchParams.get(param),
    [searchParams]
  );

  const setView = useCallback(
    (view, machine) => {
      setSearchParams({ view, m: machine });
    },
    [setSearchParams]
  );

  return {
    getParam,
    setView,
    navigate,
  };
}
